const ROOT_URL = 'https://www.greenlandhk.com';
const OSS_SERVICE_ADDRESS = "https://hkwebsite-pro-public.oss-cn-hangzhou.aliyuncs.com"
const OFFICIAL_CONFIG_URL = "https://websiteadmin.greenlandfs.com/front/mainactivity";
let BASE_CONFIG = {
    // 服务地址、页面地址
    ROOT_URL: ROOT_URL,
    // 接口超时断开时间
    REQUEST_TIMEOUT: '62000',
    // 弹窗消息延时时间
    MESSAGE_DURATION: '1500',
    // autofocus延时时间
    AUTOFOCUS_DURATION: '500',
    // modal关闭延时时间
    CLOSE_MODAL_DURATION: '200',
    // Key
    CRYPTO_KEY: 'HOPERUNFHDXLLSLZ',
    CRYPTO_KEY_OPEN: true,

    ATTACH_ADDRESS: ROOT_URL + '/front/downloadFile',
    // 图片验证码服务地址
    IMAGE_SERVLET: ROOT_URL + '/front/getRandomCode',
    // 主服务地址
    SERVICE_ADDRESS : ROOT_URL+'/front/mainactivity',
    //oss阿里云的文件上传服务器
    OSS_SERVICE_ADDRESS: OSS_SERVICE_ADDRESS,
    //CND 文件服务器
    STATICS_CDN_URL: 'https://hkwebsite-pro-public.oss-cn-hangzhou.aliyuncs.com',
    // confluence 密码
    OS_PASSWORD: 'Pass112233',
    // 明源数据oss地址替换
    MINGYUAN_URL: 'oss://hkwebsite-pro-public',
    // 官网配置页面的域名
    OFFICIAL_CONFIG_URL: OFFICIAL_CONFIG_URL,
    OFFICIAL_CONFIG_URL_ORIGIN: 'https://websiteadmin.greenlandfs.com'    
};
export {
    BASE_CONFIG
};


// WEBPACK FOOTER //
// ./src/config/config.js